import React, { useCallback } from 'react';
import cogoToast from 'cogo-toast';

import { DEBOUNCE_DURATION } from 'data/asyncSelect';
import { useLazySearchLectureBucketQuery } from '@classCreation/services/lectureBucketService';
import Select from 'components/Select';
import useDebouncedPromise from 'hooks/useDebouncedPromise';

const MIN_KEYWORD_LENGTH = 3;

export default function LectureBucketSelect(props) {
  const [fetchLectureBuckets, { isFetching }] =
    useLazySearchLectureBucketQuery();

  const generateOptions = useCallback((lectureBuckets) => {
    return lectureBuckets.map((o) => ({
      value: o.id,
      label: o.title,
    }));
  }, []);

  const loadOptions = useDebouncedPromise(
    async (keyword, callback) => {
      if (keyword.length < MIN_KEYWORD_LENGTH) return callback([]);

      const response = await fetchLectureBuckets({ keyword }, true);
      let options = [];
      if (response.data) {
        options = generateOptions(response.data.data);
      } else {
        cogoToast.error(
          response.error?.data?.message ||
            'Failed to load lecture buckets! Try again after sometime'
        );
      }
      callback(options);
    },
    DEBOUNCE_DURATION,
    [fetchLectureBuckets]
  );

  const noOptionsMessage = useCallback(
    ({ inputValue }) => {
      if (inputValue.length < MIN_KEYWORD_LENGTH) {
        return `Type atleast ${MIN_KEYWORD_LENGTH} characters to search`;
      } else if (isFetching) {
        return `Searching...`;
      } else {
        return `No matching lecture buckets found.`;
      }
    },
    [isFetching]
  );

  return (
    <Select
      type="async"
      placeholder="Select Lecture Sub Type"
      loadOptions={loadOptions}
      noOptionsMessage={noOptionsMessage}
      {...props}
    />
  );
}
